import $ from 'jquery';

$.fn.handleFormSubmissionError = function handleFormSubmissionError() {
  this.hideSpinner();
  $.rails.enableFormElements(this);
};
